import { jsx as _jsx } from "react/jsx-runtime";
import React, { PureComponent } from "react";
class AvisoAlert extends PureComponent {
    render() {
        if (!this.props.show) {
            return null;
        }
        return (_jsx("div", { className: `alert alert-${this.props.type}`, children: this.props.message || this.props.children }));
    }
}
export default AvisoAlert;
